<h2>Downloads</h2>
<div class="select-wrap">
    <mat-form-field appearance="fill" color="primary">
        <mat-label>Factory</mat-label>
        <mat-select (selectionChange)="onselectFactory()" [(ngModel)]="selectedFactoryId" required> 
            <mat-option *ngFor="let factory of factoryList" [value]="factory.id">{{factory.name}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div class="action">
    <button mat-button (click)="download(1)" [ngClass]="{'no-action':!changeOverusage ||changeOverusage && changeOverusage.length === 0}">
        <mat-icon>download</mat-icon>DOWNLOAD USAGE AS EXCEL
        <p class="error-msg" *ngIf="changeOverusage && changeOverusage.length === 0 && selectedFactoryId">No Usage Data Available</p>
    </button>
    <button mat-button (click)="download(2)" [ngClass]="{'no-action': !timeBlocks || timeBlocks && timeBlocks.length === 0}">
        <mat-icon>download</mat-icon>DOWNLOAD TIME BLOCKS AS EXCEL
        <p class="error-msg" *ngIf="timeBlocks && timeBlocks.length === 0 && selectedFactoryId">No Time block Data Available</p>
    </button>
</div>
